import { render } from "./CXClientSettings.vue?vue&type=template&id=0d55a31e&scoped=true"
import script from "./CXClientSettings.vue?vue&type=script&lang=js"
export * from "./CXClientSettings.vue?vue&type=script&lang=js"

import "./CXClientSettings.vue?vue&type=style&index=0&id=0d55a31e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d55a31e"]])

export default __exports__